import {
  List,
  TextField,
  DatagridConfigurable,
  useCanAccess,
  NumberInput,
  SelectInput,
  TextInput,
  SelectField,
  useGetOne,
} from 'react-admin';
import { ReactElement } from 'react';
import { DEFAULT_LIST_PAGE_PAGINATION_LIMIT } from '../../utils';
import { MappingErrorResource } from '../../Entities/MappingError';
import { FIELD_CHOICES } from './utils';
import LargePagination from '../../Components/LargePagination';
import { useParams } from 'react-router-dom';
import { MerchantResource } from '../../Entities/Merchant';

const filters = [
  <NumberInput alwaysOn source="equals.id" label="ID" key="id" />,
  <TextInput alwaysOn source="contains.message" label="Message" key="message" />,
  <TextInput alwaysOn source="contains.record_value" label="Record Value" key="record_value" />,
  <SelectInput source="equals.field" label="Field" choices={FIELD_CHOICES} key="field" />,
];

export default function MappingErrorReport(): ReactElement {
  const { scanId, merchantId } = useParams();
  const feedScanAccess = useCanAccess({ action: 'list', resource: 'feed_scans' });
  const merchantAccess = useCanAccess({ action: 'show', resource: 'merchants' });
  const canListFeedScans = feedScanAccess.canAccess ?? false;
  const canShowMerchant = merchantAccess.canAccess ?? false;
  const merchant = useGetOne<MerchantResource>(
    'merchants',
    { id: merchantId },
    {
      enabled: canShowMerchant,
    },
  );

  const prefetch: string[] = [];
  if (canListFeedScans) prefetch.push('feed_scan');

  return (
    <List<MappingErrorResource>
      title={`Mapping Errors for ${merchant.data?.attributes.merchant_name ?? `Merchant ID: ${merchantId}`}`}
      resource="mapping_errors"
      perPage={DEFAULT_LIST_PAGE_PAGINATION_LIMIT}
      sort={{ field: 'id', order: 'DESC' }}
      queryOptions={{ meta: { prefetch } }}
      pagination={<LargePagination />}
      filters={filters}
      filter={{
        'feed_scan.scan.id': scanId,
        'feed_scan.merchant.id': merchantId,
      }}
    >
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="relationships.feed_scan.data.id" label="Feed Scan ID" />
        <TextField source="attributes.message" label="Message" />
        <TextField source="attributes.record_value" label="Record Value" />
        <SelectField label="Field" source="attributes.field" choices={FIELD_CHOICES} />
        <TextField source="attributes.record_index" label="Record Index" />
        <TextField source="attributes.step" label="Step" />
      </DatagridConfigurable>
    </List>
  );
}
